import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVectorAnchorPointStraight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVectorAnchorPointStraight"><Circle cx="12" cy="7.75" r="3" stroke="currentColor" strokeWidth="1.5"/><Path d="M2.75 17.5L10.0526 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><Path d="M21.25 17.5L14 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVectorAnchorPointStraight;
